import { ReactComponent as TicketSvg } from '../../../../assets/icons/Ticket.svg';

import { createIconComponent } from './createIconComponent';

export const TicketIcon = createIconComponent(TicketSvg);
